<iframe id="html-preview" srcdoc="Cargando, espere por favor..." style="width: 100%; height: 500px; border: 0px;" frameborder="0"></iframe>